// extracted by mini-css-extract-plugin
export default {"deletebutton":"styles_deletebutton__tu0T3","sortableProduct":"styles_sortableProduct__8xx4i","sortableGrab":"styles_sortableGrab__wX3li"};